import React from "react";
import { useKgCanvasNavigation } from "../../kg/canvas/KgCanvasNavigationContext";
import { FocusButton, LinkedLabel } from "./KgInspectorNavLinkButton.styles";
import type { KgInspectorNavLinkButtonProps } from "./KgInspectorNavLinkButton.types";

export const KgInspectorNavLinkButton: React.FC<
  KgInspectorNavLinkButtonProps
> = ({ link }) => {
  const { focusNode } = useKgCanvasNavigation();

  if (!link.canvasNodeId) {
    return <>{link.label}</>;
  }

  return (
    <FocusButton
      type="button"
      onClick={() => focusNode(link.canvasNodeId!)}
      aria-label={`Show ${link.label} on graph`}
    >
      <LinkedLabel>{link.label}</LinkedLabel>
    </FocusButton>
  );
};

export default KgInspectorNavLinkButton;
